
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'submit-button',
components: {XButton},
props: {
text: {
type: String,
default: '提交'
},
color: {
type: String,
default: null
},
type: {
type: String,
default: 'primary'
},
loading: {
type: Boolean,
default: false
},
plain: {
type: Boolean,
default: false
},
disabled: {
type: Boolean,
default: false
},
padding: {
type: String,
default: '5%'
},
margin_top: {
type: String,
default: '24px'
}
},
methods: {
emitClick() {
if (!this.loading) {
this.$emit('click')
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/el-submit-button.vue